import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useCalorie = (userToken, shamsiDate) => {
  const baseUrl = useBaseUrl();
  const [calorieData, setCalorieData] = useState(0);
  useEffect(() => {
    const fetchCalorie = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/calorie/${shamsiDate}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setCalorieData(response.data);
      } catch (error) {
        console.log("Error during calorie request", error);
      }
    };
    if (userToken && shamsiDate) {
      fetchCalorie();
    }
  }, [baseUrl, userToken, shamsiDate]);
  return { calorieData, setCalorieData };
};

export default useCalorie;
